import React , {Fragment} from 'react'
import { Field, reduxForm } from 'redux-form';
import { simpleInputField, uploadFileField } from "../components/InputRenderers";
import LoadingIcon from '../../img/three-dots.svg' ;

const validate = (values) => {
    const errors = {};
    if (!values.name || values.name === '') {
        errors.name = "لطفا نام ناشر را وارد کنید" ;
    }
    if (!values.code || values.code === '') {
        errors.code = "لطفا کد ناشر را وارد کنید" ;
    }
    return errors;
};

let EditSettingsForm = props => {
    const { handleSubmit, loading } = props;
    return (
        <Fragment>
            <div className="sizeHandler_1185">
                <div className="addBookForm">
                    <Field name="thumbnailId" component={uploadFileField} label="آپلود لوگو"/>
                    <div className="addBookColumn">
                        <div className="formContainer">
                            <Field name="name" component={simpleInputField} label="نام ناشر" />
                            <Field name="code" component={simpleInputField} label="کد ناشر" />
                            {/*<div className="normalButton outlineMode greenButton"><span*/}
                            {/*    className="icon icon-add font-size_14 middleContext"></span> اضافه به لیست*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>

            <div className="maximumSizeHandler">
                <div className="confirmAll organizer">
                    <span className="lineSeparator"></span>
                    <div className="organizer centerText">
                        <div className="confirmationButton clickShape" onClick={handleSubmit}>
                            <span className="buttonText rightFloat">به روز رسانی</span>
                            {loading? <img src={LoadingIcon}/> :<span className="icon icon-check leftFloat"></span>}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};


const SettingsForm = reduxForm({
    // a unique name for the form
    form: "SettingsForm",
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
})(EditSettingsForm);

export default SettingsForm;